import { IDocument } from 'core/interfaces/Document'
import { PromptForm } from 'core/interfaces/Prompt'
import { PromptField } from 'lauria/components/prompts/PromptField'
import { PromptTest } from 'lauria/components/prompts/PromptTest'
import { PromptTestConversation } from 'lauria/components/prompts/PromptTestConversation'
import { usePromptConversation } from 'lauria/contexts/PromptConversationContext'
import React, { MutableRefObject, useState } from 'react'
import {
  ControllerRenderProps,
  FieldErrors,
  UseFormWatch,
} from 'react-hook-form'

export const PromptFormSide: React.FC<{
  watchPromptForm: UseFormWatch<PromptForm>
  promptRef: React.RefObject<HTMLTextAreaElement>
  errors: FieldErrors<PromptForm>
  promptField: ControllerRenderProps<PromptForm, 'prompt'>
  promptDocuments: IDocument[]
  promptNewFiles: File[]
  addTextToTextarea: (
    event: React.MouseEvent,
    text: string,
    ref: MutableRefObject<any>,
    fieldName: string
  ) => void
}> = ({
  watchPromptForm,
  promptRef,
  promptField,
  errors,
  promptDocuments,
  promptNewFiles,
  addTextToTextarea,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { conversation } = usePromptConversation()
  return (
    <div className="prompt-form-test">
      <div
        className={`prompt-form-side ${conversation.messages.length > 0 || isLoading ? 'flex-[5]' : 'flex'}`}
      >
        <PromptField
          promptField={promptField}
          promptRef={promptRef}
          addTextToTextarea={addTextToTextarea}
          errors={errors}
        />
        <PromptTest
          watchPromptForm={watchPromptForm}
          setIsLoading={setIsLoading}
          promptDocuments={promptDocuments}
          promptNewFiles={promptNewFiles}
        />
      </div>
      {(conversation.messages.length > 0 || isLoading) && (
        <PromptTestConversation
          watchPromptForm={watchPromptForm}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}
